interface PrivacyScreenProps {
  navigate(path: string): void;
}

export function PrivacyScreen({ navigate }: PrivacyScreenProps) {
  return (
    <main className="page privacy-page">
      <header className="page-header">
        <button className="link" onClick={() => navigate('/profile')} style={{ marginBottom: '8px' }}>
          ← Quay lại
        </button>
        <h1>📜 Chính Sách Quyền Riêng Tư</h1>
        <p className="tagline">Cập nhật lần cuối: Tháng 9/2026</p>
      </header>

      <div className="card privacy-content">
        <section>
          <h2>1. Giới thiệu</h2>
          <p>
            Chào mừng bạn đến với <strong>Kỳ Chiến</strong> (kychien.vn). Chúng tôi tôn trọng quyền riêng tư của bạn và cam kết bảo vệ dữ liệu cá nhân của người dùng khi sử dụng ứng dụng trên mọi nền tảng (iOS, Android, Web).
          </p>
        </section>

        <section>
          <h2>2. Dữ liệu chúng tôi thu thập</h2>
          <ul>
            <li><strong>Thông tin tài khoản:</strong> Tên hiển thị (Display Name), tên đăng nhập (Username) và mật khẩu đã được mã hóa một chiều (Bcrypt Hash).</li>
            <li><strong>Dữ liệu ván đấu:</strong> Biên bản nước đi cờ tướng, thời gian thi đấu, kết quả ván cờ (thắng/thua/hòa) và điểm số xếp hạng.</li>
            <li><strong>Dữ liệu xã hội:</strong> Lời mời và danh sách bạn bè, tin nhắn trực tiếp, lời mời đấu và thông báo liên quan.</li>
            <li><strong>Không thu thập:</strong> Chúng tôi <em>không</em> thu thập vị trí GPS, không đọc danh bạ, không truy cập thư viện ảnh hoặc bất kỳ dữ liệu nhạy cảm nào khác trên thiết bị của bạn.</li>
          </ul>
        </section>

        <section>
          <h2>3. Mục đích sử dụng dữ liệu</h2>
          <p>
            Dữ liệu được sử dụng để vận hành trò chơi, kết nối bạn bè, gửi tin nhắn và lời mời đấu, lưu biên bản để xem lại ván cờ, tính thống kê và bảo vệ dịch vụ. Chúng tôi không bán dữ liệu người dùng.
          </p>
        </section>

        <section>
          <h2>4. Bảo mật & Lưu trữ</h2>
          <p>
            Mọi dữ liệu truyền tải giữa thiết bị của bạn và hệ thống máy chủ đều được mã hóa bằng giao thức bảo mật cao nhất (HTTPS và WSS - Secure WebSocket). Mật khẩu của bạn được băm an toàn và không ai, kể cả quản trị viên, có thể đọc được mật khẩu gốc.
          </p>
        </section>

        <section>
          <h2>5. Quyền của người dùng & Xóa tài khoản</h2>
          <p>
            Bạn có thể yêu cầu xóa tài khoản tại mục <strong>Trang cá nhân ➔ Xóa tài khoản</strong>. Thông tin đăng nhập, lời mời và quan hệ bạn bè, tin nhắn, cùng thông báo của tài khoản sẽ bị xóa. Biên bản và kết quả ván đấu được giữ lại để bảo đảm lịch sử trận và thống kê; tên hiển thị được thay bằng “Tài khoản đã xóa”.
          </p>
        </section>

        <section>
          <h2>6. Liên hệ</h2>
          <p>
            Nếu bạn có bất kỳ câu hỏi hoặc khiếu nại nào về chính sách quyền riêng tư, vui lòng liên hệ qua email hỗ trợ của nhà phát triển: <code>support@kychien.vn</code>.
          </p>
        </section>
      </div>

      <button className="link" onClick={() => navigate('/profile')} style={{ marginTop: '16px' }}>
        ← Quay lại Trang cá nhân
      </button>
    </main>
  );
}
